import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const supplyOrderApprovalPageRBAC = {
  pageID: 'e5e76b6aedd6a33369815c572e39bbca',
  elementID: {
    TableList: 'dc727f88bc91594c40c2af9bd264ce9a',
    BtnReviewWaitingApproval: '9cc65d0a0611436a68c23ef07707f096',
    BtnReviewInReviewIC: 'dcd084bb0e89d1c68e455968279fad23',
    BtnReviewInReviewLP: 'dcd084bb1389d1c68e455968279fb317',
    BtnReviewWaitingTimLossPrevention: '9c94c6affa20d509a61a3953d41e27c6',
  },
} as const

export const useRBACSupplyOrderApprovalPage = createUseRBAC(supplyOrderApprovalPageRBAC.elementID)

export type UseRBACSupplyOrderApprovalPageType = ReturnType<typeof useRBACSupplyOrderApprovalPage>
